export function getISBN(state) {
  return state.viewer.isbn;
}

export function isViewerReady(state) {
  return state.viewer.isReady;
}

export function isSnippet(state) {
  return !!getSnippetRange(state);
}

export function getSnippetRange(state): string | undefined {
  return state.viewer.snippetRange;
}
